"use client";

import { getApiErrorDescription } from "@/services/api-client";
import { toast, type ExternalToast } from "sonner";

type ApiErrorToastOptions = Omit<ExternalToast, "description" | "id"> & {
  description?: string;
  getDescription?: (error: unknown) => string;
  id?: string;
};

export function showApiErrorToast(
  title: string,
  error: unknown,
  options: ApiErrorToastOptions = {},
) {
  const {
    description: providedDescription,
    getDescription = getApiErrorDescription,
    id,
    ...toastOptions
  } = options;
  const description = providedDescription || getDescription(error);

  toast.error(title, {
    id: id || `api-error:${title}:${description}`,
    description,
    ...toastOptions,
  });
}
